import { useState, useEffect } from "react";
import { getBranchUsers } from "../services/branch_users";

// Global cache keyed by params string
const branchUsersCache = {};

export const useBranchUsers = ({ reload = false, params = {} } = {}) => {
  const key = JSON.stringify(params); // unique cache key for these params
  const [branchUsers, setBranchUsers] = useState(branchUsersCache[key] || []);
  const [loading, setLoading] = useState(false);

  const fetchBranchUsers = async () => {
    setLoading(true);
    try {
      const [err, data] = await getBranchUsers(params);
      if (!err) {
        branchUsersCache[key] = data || [];
        setBranchUsers(branchUsersCache[key]);
      }
    } catch (e) {
      console.error("Error fetching branch users:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!branchUsersCache[key] || reload) {
      fetchBranchUsers();
    } else {
      setBranchUsers(branchUsersCache[key]);
    }
  }, [key, reload]);

  return { branchUsers, loading, refresh: fetchBranchUsers };
};
